import { GET_MEMOIRS } from '../actions/types';

const initState = {
	memoirs: [],
	allMemoirs: [],
	publicMemoirs: [],
	singleMemoir: {},
	singleMedia: [],
	loading: false,
	coverLoading: false,
	mediaLoading: false,
};

const memoirReducer = (state = initState, action) => {
	switch (action.type) {
		case GET_MEMOIRS:
			return {
				...state,
				memoirs: action.memoirs,
			};
		case 'GET_ALL_MEMOIRS': {
			return {
				...state,
				allMemoirs: action.payload,
			};
		}
		case 'GET_PUBLIC_MEMOIRS': {
			return {
				...state,
				publicMemoirs: action.payload,
			};
		}
		case 'GET_SINGLE_MEMOIR': {
			return {
				...state,
				singleMemoir: action.memoir,
			};
		}
		case 'GET_SINGLE_MEDIA': {
			return {
				...state,
				singleMedia: action.media,
			};
		}
		case 'MEMOIR_ACTION_START': {
			return {
				...state,
				loading: true,
			};
		}
		case 'MEMOIR_ACTION_END': {
			return {
				...state,
				loading: false,
			};
		}
		case 'MEMOIR_COVER_ACTION_START': {
			return {
				...state,
				coverLoading: true,
			};
		}
		case 'MEMOIR_COVER_ACTION_END': {
			return {
				...state,
				coverLoading: false,
			};
		}
		case 'SET_MEMOIR_MEDIA_LOADING': {
			return {
				...state,
				mediaLoading: action.payload,
			};
		}
		default:
			return state;
	}
};

export default memoirReducer;
